<template>
    <div class="base-counter">
        <div
            :class="{ 'base-counter__button_disabled': !isSubCount }"
            class="base-counter__button"
            @click="subCount"
        >
            <LinceIconRemove class="base-counter__button-icon"/>
        </div>
        <input
            type="number"
            v-model="count"
            :min="minCount"
            :max="maxCount"
            style="appearance: textfield;"
        >
        <div
            :class="{ 'base-counter__button_disabled': !isAddCount }"
            class="base-counter__button"
            @click="addCount"
        >
            <LinceIconAdd class="base-counter__button-icon"/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BaseCounter',
    props: {
        minCount: {
            type: Number,
            default: 0
        },
        maxCount: {
            type: Number,
            default: 0
        },
        valueCount: {
            type: Number,
            default: 0
        }
    },
    data: () => ({
        // count: 0
    }),
    computed: {
        count: {
            get() {
                return this.valueCount
            },
            set(newCount) {
                this.updateCount(newCount);
            }
        },
        isSubCount() {
            return this.count > this.minCount;
        },
        isAddCount() {
            return this.count < this.maxCount;
        }
    },
    watch: {
        minCount() {
            this.updateCount(this.count);
        },
        maxCount() {
            this.updateCount(this.count);
        }
    },
    methods: {
        addCount() {
            if (this.isAddCount)
                ++this.count;
        },
        subCount() {
            if (this.isSubCount)
                --this.count;
        },
        updateCount(newCount = 0) {
            let count = parseInt(newCount);
    
            if (count > this.maxCount)
                count = this.maxCount;
            else if (count < this.minCount)
                count = this.minCount;

            this.$emit('update:valueCount', count);
        }
    }
}
</script>

<style lang="scss" scoped>
    .base-counter {
        display: flex;

        input[type="number"] {
            width: 36px;
            height: 36px;
            border: 1px solid #dcdfe5;
            border-radius: 10px;
            display: inline-block;
            text-align: center;
            margin-right: 4px;

            &:active, &:hover, &:focus {
                outline: 0;
                outline-offset: 0;
            }

            &::-webkit-outer-spin-button, &::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }
        }

        &__button {
            background: #fff;
            font-size: 14px;
            font-weight: bold;
            text-align: center;
            line-height: 34px;
            border: 1px solid #dcdfe5;
            border-left-color: rgb(220, 223, 229);
            border-left-style: solid;
            border-left-width: 1px;
            cursor: pointer;
            outline: 0;
            -webkit-transition: all 250ms;
            -moz-transition: all 250ms;
            transition: all 250ms;

            display: flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            height: 36px;
            border-radius: 10px;
            padding: 0;
            margin-right: 4px;

            &-icon {
                width: 18px;
                height: 18px;
            }

            &_disabled {
                color: #dcdfe5;
                cursor: default;
            }
        }
    }
</style>